import { Dialog, DialogActions, DialogContent } from '@mui/material';
import { DialogTitle } from '@mui/material';
import React from 'react';
import Uploader from '../../../../../../../lib/designSystem/Uploader';
import CustomButton from '../../../../../../../lib/designSystem/Button';

const UploadDialog = (props: any) => {
  const {
    openUploadFile,
    setOpenUploadFile,
    handleFileChange,
    uploadedFileName,
    setUploadedFileName,
    handleUploadFile,
  } = props;

  return (
    <Dialog open={openUploadFile} onClose={() => setOpenUploadFile(false)}>
      <DialogTitle>Subir documento</DialogTitle>
      <DialogContent>
        <Uploader
          buttonText="Subir documento"
          handleFileChange={handleFileChange}
          uploadedFileName={uploadedFileName}
          setUploadedFileName={setUploadedFileName}
        />
      </DialogContent>
      <DialogActions>
        <CustomButton
          onClick={() => setOpenUploadFile(false)}
          color="secondary"
        >
          Cancelar
        </CustomButton>
        <CustomButton onClick={handleUploadFile} color="primary">
          Subir
        </CustomButton>
      </DialogActions>
    </Dialog>
  );
};

export default UploadDialog;
